import styled from 'styled-components';

export const Container = styled.div`
  .SingleDatePickerInput {
    display: flex;
    align-items: center;
    border-color: ${(props) => props.theme.$gray400};
    border-radius: 0.25rem;
    overflow: hidden;
  }

  .DateInput {
    flex: 1;
  }

  .DateInput_input {
    width: 100%;
    height: calc(1.5em + 0.75rem);
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    color: ${(props) => props.theme.$dark};
  }

  .SingleDatePicker_picker {
    z-index: 1050;
  }
`;
